import { ApolloClient, gql } from '@apollo/client'

/**
 * The caller's own effective feature-config map (PRO-459 field-level seam).
 * login-only; MODULE_FLAG keys read through the legacy column, UI_ELEMENT /
 * CONFIG keys resolve rules. gql-only leaf (PRO-130) — safe to prefetch in the
 * boot batch; `useFeatureConfigValue` reads it cache-first.
 */
export const MY_FEATURE_CONFIG = gql`
  query MyFeatureConfig {
    myFeatureConfig {
      key
      kind
      valueType
      value
    }
  }
`

/** Fire-and-forget boot prefetch (mirrors DASHBOARD_CONFIGS): warms the cache so
 * the cache-first hook never pays a round trip on mount. */
export const prefetchMyFeatureConfig = (client: ApolloClient<object>) =>
  client.query({ query: MY_FEATURE_CONFIG }).catch(() => undefined)
